<div class="ai-usage-dashboard">
  <div class="ai-usage-toolbar">
    <div class="ai-usage-presets" role="group" aria-label="Date range presets">
      <button
        type="button"
        class="preset-btn"
        [class.active]="datePreset === '7d'"
        (click)="onPresetChange('7d')"
      >
        Last 7 days
      </button>
      <button
        type="button"
        class="preset-btn"
        [class.active]="datePreset === '30d'"
        (click)="onPresetChange('30d')"
      >
        Last 30 days
      </button>
      <button
        type="button"
        class="preset-btn"
        [class.active]="datePreset === 'month'"
        (click)="onPresetChange('month')"
      >
        This month
      </button>
      <button
        type="button"
        class="preset-btn"
        [class.active]="datePreset === 'custom'"
        (click)="onPresetChange('custom')"
      >
        <mat-icon class="preset-icon">tune</mat-icon>
        Custom
      </button>
    </div>

    <div class="ai-usage-filters" *ngIf="datePreset === 'custom'">
      <mat-form-field appearance="outline" class="ai-usage-date-field">
        <mat-label>From</mat-label>
        <input
          matInput
          [matDatepicker]="fromPicker"
          [max]="toDate || today"
          [(ngModel)]="fromDate"
          readonly
          (click)="fromPicker.open()"
        />
        <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
        <mat-datepicker #fromPicker></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="outline" class="ai-usage-date-field">
        <mat-label>To</mat-label>
        <input
          matInput
          [matDatepicker]="toPicker"
          [min]="fromDate"
          [max]="today"
          [(ngModel)]="toDate"
          readonly
          (click)="toPicker.open()"
        />
        <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
        <mat-datepicker #toPicker></mat-datepicker>
      </mat-form-field>
    </div>

    <button
      type="button"
      class="ai-usage-apply-btn"
      (click)="applyFilters()"
      [disabled]="loading"
    >
      <mat-icon class="apply-icon" [class.spin]="loading">refresh</mat-icon>
      {{ loading ? 'Loading…' : 'Apply' }}
    </button>
  </div>

  <div class="ai-usage-error" *ngIf="errorMessage">{{ errorMessage }}</div>

  <div class="ai-usage-kpis">
    <div class="kpi-card">
      <span class="kpi-label">Conversations</span>
      <span class="kpi-value">{{ kpis.conversations | number }}</span>
    </div>
    <div class="kpi-card">
      <span class="kpi-label">Messages</span>
      <span class="kpi-value">{{ kpis.messages | number }}</span>
    </div>
    <div class="kpi-card">
      <span class="kpi-label">Input Tokens</span>
      <span class="kpi-value">{{ kpis.inputTokens | number }}</span>
    </div>
    <div class="kpi-card">
      <span class="kpi-label">Output Tokens</span>
      <span class="kpi-value">{{ kpis.outputTokens | number }}</span>
    </div>
    <div class="kpi-card">
      <span class="kpi-label">Total Tokens</span>
      <span class="kpi-value">{{ kpis.totalTokens | number }}</span>
    </div>
  </div>

  <div class="ai-usage-chart-card du-card">
    <div class="section-title">Daily Token Usage</div>
    <div class="ai-usage-chart" *ngIf="dailyUsage.length; else noChart">
      <div class="chart-yaxis-title">Tokens</div>

      <div class="chart-yaxis">
        <span
          class="chart-yaxis-tick"
          *ngFor="let tick of yAxisTicks(); let i = index; let count = count"
          [style.top.%]="(i / (count - 1)) * 100"
        >{{ tick.label }}</span>
      </div>

      <div class="chart-plot">
        <div class="chart-gridlines">
          <span
            class="chart-gridline"
            *ngFor="let tick of yAxisTicks(); let i = index; let count = count"
            [style.top.%]="(i / (count - 1)) * 100"
          ></span>
        </div>
        <div class="chart-bars">
          <div class="chart-bar" *ngFor="let point of dailyUsage">
            <div class="chart-bar-stack">
              <div
                class="chart-bar-fill"
                [style.height]="barHeight(point.tokens)"
                [matTooltip]="barTooltip(point)"
                matTooltipClass="ai-usage-bar-tooltip"
                matTooltipPosition="above"
              ></div>
            </div>
            <span class="chart-label">{{ point.label }}</span>
          </div>
        </div>
      </div>
    </div>
    <ng-template #noChart>
      <div class="ai-usage-empty">No usage data for the selected period.</div>
    </ng-template>
  </div>

  <div class="ai-usage-grid-card du-card">
    <div class="card-header-row">
      <div class="section-title">Conversations</div>
      <mat-icon
        class="grid-export-icon"
        svgIcon="dotmenu_circle"
        matTooltip="Export"
        [class.disabled]="!records.length"
        [matMenuTriggerFor]="records.length ? exportMenu : null"
      ></mat-icon>
      <mat-menu #exportMenu="matMenu" class="ai-usage-export-menu" xPosition="before">
        <button mat-menu-item type="button" (click)="exportToExcel()">
          <mat-icon svgIcon="xls"></mat-icon>
          <span>Export to Excel</span>
        </button>
      </mat-menu>
    </div>
    <div class="grid-wrap">
      <ag-grid-angular
        class="ag-theme-balham ai-usage-grid"
        [rowData]="records"
        [columnDefs]="columnDefs"
        [defaultColDef]="defaultColDef"
        [animateRows]="true"
        [pagination]="false"
        [domLayout]="'autoHeight'"
        (gridReady)="onGridReady($event)"
        (rowClicked)="onRowClicked($event)"
      ></ag-grid-angular>
    </div>
    <div class="ai-usage-loading" *ngIf="loading">Loading usage data...</div>
  </div>
</div>

<div class="ai-usage-detail-backdrop" *ngIf="detailOpen" (click)="closeDetail()"></div>
<aside class="ai-usage-detail-panel" [class.open]="detailOpen">
  <div class="detail-header">
    <div class="detail-header-main">
      <div class="detail-heading-row">
        <span class="detail-avatar">
          <mat-icon>forum</mat-icon>
        </span>
        <div class="detail-heading-text">
          <h3 class="detail-title">Conversation Detail</h3>
          <p class="detail-meta" *ngIf="selectedConversation">
            <mat-icon class="detail-meta-icon">person</mat-icon>
            <span class="detail-meta-text">{{ selectedConversation.user_id }}</span>
            <span class="detail-meta-dot">•</span>
            <mat-icon class="detail-meta-icon">schedule</mat-icon>
            <span class="detail-meta-text">{{ formatDateTime(selectedConversation.last_message_at) }}</span>
          </p>
        </div>
      </div>
      <p class="detail-preview" *ngIf="selectedConversation">{{ selectedConversation.preview }}</p>
    </div>
    <button mat-icon-button type="button" class="detail-close" (click)="closeDetail()" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="detail-summary" *ngIf="conversationDetail">
    <div class="detail-stat detail-stat--token">
      <span class="detail-stat-label">Input Tokens</span>
      <span class="detail-stat-value">{{ formatNumber(conversationDetail.input_tokens) }}</span>
    </div>
    <div class="detail-stat detail-stat--token">
      <span class="detail-stat-label">Output Tokens</span>
      <span class="detail-stat-value">{{ formatNumber(conversationDetail.output_tokens) }}</span>
    </div>
    <div class="detail-stat detail-stat--token">
      <span class="detail-stat-label">Total Tokens</span>
      <span class="detail-stat-value">{{ formatNumber(conversationDetail.total_tokens) }}</span>
    </div>
  </div>

  <div class="detail-body">
    <div class="detail-body-title" *ngIf="conversationDetail?.messages?.length">
      Messages
      <span class="detail-body-count">{{ conversationDetail?.messages?.length }}</span>
    </div>
    <div class="ai-usage-loading" *ngIf="detailLoading">Loading messages...</div>
    <div class="ai-usage-error" *ngIf="detailError">{{ detailError }}</div>
    <ag-grid-angular
      *ngIf="conversationDetail?.messages?.length"
      class="ag-theme-balham ai-usage-message-grid"
      [rowData]="conversationDetail?.messages"
      [columnDefs]="messageColumnDefs"
      [defaultColDef]="defaultColDef"
      [domLayout]="'autoHeight'"
    ></ag-grid-angular>
  </div>
</aside>
